import {Injectable} from '@angular/core';
import {RequestOptions, ResponseContentType} from '@angular/http';

import {environment} from '../../../environments/environment';
import {HttpService} from './http.service';

@Injectable()
export class PrintService {
  options: RequestOptions;

  constructor(private http: HttpService) {
    this.options = new RequestOptions();
    this.options.responseType = ResponseContentType.Blob;
  }

  printXlsx(body = {}) {
    return this.http.post(`${environment.PRINTABLE_URL}/xlsx/from/json`, body, this.options);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/print.service.ts